export default __webpack_public_path__ + "static/media/347.e2e527a4.png";